import axios from "axios";

/**
 * Axios instance with pre-configured settings for the Malayan API.
 * @typedef {Object} AxiosInstance
 */
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("idToken");

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default axiosInstance;
